/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var React = require('react');
var SVGSet = require('../../src/SVGSet');
var Logo = require('../../src/Logo');
var packageJson = require('../../../../package.json');

var DocHeader = React.createClass({displayName: "DocHeader",
  render:function() {
    return (
      React.createElement("div", {className: "header"}, 
        React.createElement("div", {className: "miniHeader"}, 
          React.createElement("div", {className: "miniHeaderContents"}, 
            React.createElement("a", {href: "../", target: "_self", className: "miniLogo"}, 
              React.createElement(SVGSet, null, 
                React.createElement(Logo, {color: "#FC4349"}), 
                React.createElement(Logo, {color: "#2C3E50", inline: true})
              )
            ), 
            React.createElement("a", {href: "./", target: "_self"}, 
              "Docs (v", 
              packageJson.version, ")"
            ), 
            React.createElement("a", {href: "https://stackoverflow.com/questions/tagged/immutable.js?sort=votes"}, 
              "Questions"
            ), 
            React.createElement("a", {href: "https://github.com/facebook/immutable-js/"}, "Github")
          )
        )
      )
    );
  },
});

module.exports = DocHeader;
